import { createMedia } from '@artsy/fresnel'
import { breakpoints } from '@constants'

const CreateBreakpoints = createMedia({ breakpoints })

export const mediaStyles = CreateBreakpoints.createMediaStyle()

export const { Media, MediaContextProvider } = CreateBreakpoints